export const tags = (t) => [
    { id: 'analyze', label: t('opportunities.discover.tabs.content_analysis') },
    { id: 'entities', label: t('opportunities.discover.tabs.entities') },
    { id: 'pages', label: t('opportunities.discover.tabs.page_refreshes') },
    { id: 'lowCTR', label: t('opportunities.discover.tabs.underperforming_CTR') },
    // { id: 'all', label:t("opportunities.discover.tabs.all")},
];
